export default __webpack_public_path__ + "static/media/last_img_main.ae932d93.png";